const WEIGHT = {
	install (Vue, options) {
		Vue.prototype.$weight = {

			bitRoundToTwo (num, pow) {
				return Math.round(num / Math.pow(1024, pow) * 100) / 100
			},

			bitRoundToThree (num, pow) {
				return Math.round(num / Math.pow(1024, pow) * 1000) / 1000
			},

			octalRoundToTwo (num, pow) {
				return Math.round(num / Math.pow(1000, pow) * 100) / 100
			},

			octalRoundToThree (num, pow) {
				return Math.round(num / Math.pow(1000, pow) * 1000) / 1000
			},

			humanizeWeight (weight, base) {
				if (!weight) {
					weight = '-'
				} else if (isNaN(parseInt(weight))) {
					weight = '-'
				} else {
					let unit = 'o'
					if (base === 1024) unit = 'i' + unit
					if (String(weight).length < 7) {
						weight = Math.round(weight / Math.pow(base, 1) * 100) / 100 + ' K' + unit
					} else if (String(weight).length >= 7 && String(weight).length < 10) {
						weight = Math.round(weight / Math.pow(base, 2) * 100) / 100 + ' M' + unit
					} else if (String(weight).length >= 10 && String(weight).length < 13) {
						weight = Math.round(weight / Math.pow(base, 3) * 100) / 100 + ' G' + unit
					} else if (String(weight).length >= 13 && String(weight).length < 16) {
						weight = Math.round(weight / Math.pow(base, 4) * 100) / 100 + ' T' + unit
					} else if (String(weight).length >= 16) {
						weight = Math.round(weight / Math.pow(base, 5) * 100) / 100 + ' P' + unit
					} else {
						weight = 'N/A'
					}
				}
				return weight
			}

		}
	}
}

export default WEIGHT



// WEBPACK FOOTER //
// ./src/plugins/weight.js